if (!customElements.get('contact-editorial')) {
  class ContactEditorial extends HTMLElement {
    connectedCallback() {
      this.enquirySelect = this.querySelector('[data-contact-enquiry-select]');
      this.enquiryHidden = this.querySelector('[data-contact-enquiry-hidden]');
      this.eventFields = Array.from(this.querySelectorAll('[data-contact-event-field]'));
      this.eventTriggers = this.parseTriggers(this.dataset.eventTriggers || '');

      if (!this.enquirySelect) return;

      this.onEnquiryChange = this.updateEventFields.bind(this);
      this.enquirySelect.addEventListener('change', this.onEnquiryChange);
      this.updateEventFields();
    }

    disconnectedCallback() {
      if (this.enquirySelect && this.onEnquiryChange) {
        this.enquirySelect.removeEventListener('change', this.onEnquiryChange);
      }
    }

    parseTriggers(raw) {
      return raw
        .split('||')
        .map((value) => this.handleize(value))
        .filter(Boolean);
    }

    handleize(value) {
      return value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    updateEventFields() {
      const selectedLabel = this.enquirySelect?.value || '';
      const selectedValue = this.handleize(selectedLabel);
      const isEventType = this.eventTriggers.includes(selectedValue);

      if (this.enquiryHidden) {
        this.enquiryHidden.value = selectedLabel;
      }

      this.eventFields.forEach((field) => {
        field.hidden = !isEventType;

        field.querySelectorAll('input, select, textarea').forEach((input) => {
          input.disabled = !isEventType;
        });
      });
    }
  }

  customElements.define('contact-editorial', ContactEditorial);
}
